<template>
	<vx-card class="mt-5 select-author">
		<vs-popup class="select-author__popup" title="" :active.sync="authorsSelectPopup">
			<div class="vx-row">
				<div class="vx-col sm:w-1/2 w-full mb-8">
					<div
						class="vs-component  w-full vs-con-input-label vs-input vs-input-primary"
					>
						<label class="vs-input--label">{{ $t('subjectArea') }}</label>
						<div class="vs-con-input"></div>
						<v-select
							v-model="subjectAuthor"
							:reduce="(subjects) => subjects.id"
							:options="subjects"
							:dir="$vs.rtl ? 'rtl' : 'ltr'"
							name="work"
							label="name"
							class="single-row-select"
						/>
					</div>
					<span class="text-danger text-sm">{{
							errors.first("work")
						}}</span>
				</div>
				<div class="vx-col w-full mb-3 search">
					<vs-input
						v-model="searchAuthor"
						icon="search"
						icon-after
						:placeholder="$t('searchByNameAndClient')"
						class="w-full"
					/>
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col w-full">
					<vs-table multiple v-model="selected"  :data="authors">
						<template slot="thead">
							<vs-th>
								{{ $t('author') }}
							</vs-th>
							<vs-th>
								{{ $t('rating') }}
							</vs-th>
							<vs-th>
								{{ $t('totalWorks') }}
							</vs-th>
							<vs-th>
								{{ $t('currentWorks') }}
							</vs-th>
							<vs-th>
								{{ $t('favorites') }}
							</vs-th>
						</template>
						<template slot-scope="{data}">
							<vs-tr
								v-for="(tr, indextr) in data"
								:key="indextr"
								:data="tr"
							>
								<vs-td :data="data[indextr].first_name + data[indextr].last_name">
									<RouterLink :to="`/${pathToAuthor}/${data[indextr].id}`">
										<div @click="closePopup" class="flex item-center">
											<div
												v-if="data[indextr].photo != undefined && data[indextr].photo != null" 
												class="author-photo"
											>
												<img :src="data[indextr].photo">
											</div>
											<div class="author-name whitespace-no-wrap">
												{{ data[indextr].first_name }} {{ data[indextr].last_name }}
											</div>
										</div>
									</RouterLink>
								</vs-td>

								<vs-td :data="data[indextr].rating">
									<div v-if="data[indextr].rating == null">
										{{ $t(`newbie`) }}
									</div>
									<div v-if="data[indextr].rating != null">
										{{data[indextr].rating}}
									</div>
								</vs-td>

								<vs-td :data="data[indextr].orders_count">
									{{data[indextr].orders_count}}
								</vs-td>

								<vs-td :data="data[indextr].orders_active_count">
									{{data[indextr].orders_active_count}}
								</vs-td>

								<vs-td :data="data[indextr].is_favorite">
									<div
										@click.stop="toggleFavorite(data[indextr])"
										class="select-author__favorite"
									>
										<img
											v-if="!data[indextr].is_favorite"
											src="@/assets/images/svg/star.svg"
										>
										<img
											v-if="data[indextr].is_favorite"
											src="@/assets/images/svg/filled-star.svg"
										>
									</div>
								</vs-td>
							</vs-tr>
						</template>
					</vs-table>
				</div>
			</div>
			<div class="vx-row">
				<div class="vx-col mt-5 w-full justify-end flex">
					<vs-button
						v-if="selected.length > 0"
						color="success"
						@click="inviteAuthors"
					>{{ $t('invite') }}</vs-button>

					<vs-button
						v-else
						disabled
						color="success"
					>{{ $t('invite') }}</vs-button>
				</div>
			</div>
		</vs-popup>
		<div class="author-search-requests head flex items-center justify-between pb-4">
			<h2>{{ $t('performersRequests') }}</h2>
			<vs-button @click="authorsSelectPopup = true">{{ $t('invite') }}</vs-button>
		</div>
		<vs-table :data="requests">
			<template slot="thead">
				<vs-th>
					{{ $t('author') }}
				</vs-th>
				<vs-th>
					{{ $t('rating') }}
				</vs-th>
				<vs-th>
					{{ $t('totalWorks') }}
				</vs-th>
				<vs-th>
					{{ $t('currentWorks') }}
				</vs-th>
				<vs-th>
				</vs-th>
			</template>
			<template slot-scope="{data}">
				<vs-tr :key="indextr" v-for="(tr, indextr) in data" :class="{active: tr.is_favorite}" >
					<vs-td>
						<div class="flex items-center">
							<img 
								v-if="data[indextr].author.photo != undefined && data[indextr].author.photo != null" 
								:src="data[indextr].author.photo" class="author-search-requests__photo mini-img mr-3 "
							>
							{{data[indextr].author.username}}
						</div>
					</vs-td>

					<vs-td :data="requests[indextr].author.rating">
						<div v-if="data[indextr].author.rating == null">
							{{ $t(`newbie`) }}
						</div>
						<div v-if="data[indextr].author.rating != null">
							{{data[indextr].author.rating}}
						</div>
					</vs-td>

					<vs-td :data="requests[indextr].orders_count">
						{{data[indextr].orders_count}}
					</vs-td>

					<vs-td :data="requests[indextr].orders_active_count">
						{{data[indextr].orders_active_count}}
					</vs-td>

					<vs-td :data="data[indextr].author.id">
						<vs-button
							size="small"
							@click="setAuthor(data[indextr].author.id)"
							color="success"
						>{{ $t('select') }}</vs-button>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</vx-card>
</template>

<script>
import databaseManager from "@/mixins/databaseManager";
import notifier from "@/mixins/notifier";
import vSelect from "vue-select";

export default {
	name: "AuthorSelect",
	mixins: [databaseManager, notifier],
	props: {
		orderId:    { default: -1, type: Number },
		// levels: 	{ default: [] },
		subjects: 	{ default: [] },
	},
	components: {
		vSelect
	},
	data() {
		return {
			authorsSelectPopup: false,
			searchAuthor: '',
			requests: [],
			subjectAuthor: '',
			selected: [],
			authors: [],
		}
	},
	watch: {
		authorsSelectPopup(newValue) {
			if(newValue === false) {
				this.selected = [];
				this.searchAuthor = '';
				this.subjectAuthor = '';
			}
		},
		searchAuthor() {
			this.updateList();
		},
		subjectAuthor() {
			this.updateList();
		}
	},
	computed: {
		pathToAuthor() {
			const role = this.$store.state.auth.role;
			if(role === "manager") {
				return "authorM"
			} else if(role === "admin") {
				return "author";
			}
		},
	},
	methods: {
		changeRequestFavorite(userId, value) {
			const request = this.requests.find(item => item.author.user_id === userId);

			if(!!request) {
				request.is_favorite = value;
			}
		},
		async toggleFavorite(author) {
			try {
				const newValue = !author.is_favorite;
				author.is_favorite = newValue;

				if(newValue === true) {
					await this.dbAddAuthorToFavorite(author.id);
				} else {
					await this.dbDeleteAuthorFromFavorite(author.id);
				}

				this.sortAuthors();
				this.changeRequestFavorite(author.user_id, newValue);

			} catch(e) {
				this.notifyError(e.message);
			}
		},
		async inviteAuthors() {
			try{
				this.authorsSelectPopup = false;
				let promises = [];
				for(let author of this.selected) {
					promises.push(this.dbInviteAuthor(this.orderId, author.id));
				}

				await Promise.all(promises);

				this.notifySuccess(this.$t('yourRequestsWasSentSuccessfully'));

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		closePopup() {
			this.authorsSelectPopup = false;
		},
		async setAuthor(authorId) {
			try{
				await this.dbSetAuthor(this.orderId, authorId);
				this.notifySuccess(this.$t('youHaveAssignedAuthorToThisProject'));
				this.$emit("updateModel");

			}catch (e) {
				this.notifyError(e.message);
			}
		},
		sortAuthors() {
			this.authors.sort((a, b) => {
				if(b.is_favorite) {
					return 1;
				} else if(a.is_favorite === true) {
					return -1;
				} else {
					return 0;
				}
			});
		},
		async updateList() {
			try {
				const options = {
					name: this.searchAuthor !== '' ? this.searchAuthor : undefined,
					subject: Number.isInteger(this.subjectAuthor) ? this.subjectAuthor : undefined
				};

				const res = await this.dbGetAuthorInviteList(options);
				this.authors = res || [];
				this.sortAuthors();

			} catch(e) {
				this.notifyError(e.message);
			}
		}
	},
	async mounted() {
		const role = this.$store.state.auth.role;

		await this.updateList();

		if(role === 'manager' || role === 'admin') {
			const requestsUrl = `/${role}/order/get-author-requests/${this.$route.params.id}`;
			const requestsRes = (await this.$http.get(requestsUrl));
			this.requests = requestsRes.data.data;
		}
	}
}
</script>

<style lang="scss">
@import "./src/assets/scss/vuexy/variables";

.select-author__popup {
	.vs-popup {
		//height: 520px;
		max-height: 100%;
		padding: 0 15px !important;
		max-width: 600px !important;
		width: 100% !important;

		&--content{
			width: 100%;
			height: 100%;
			padding: 13px 0;
		}

		.vx-row {
			margin-left: 0;
			margin-right: 0;
		}
	}

	.author-photo {
		width: 25px;
		height: 25px;
		border-radius: 100%;
		overflow: hidden;
		margin-right: 6px;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.author-name {
		color: $primary;
		text-decoration: underline;
	}

	.input-search {
		border: rgba(60, 60, 60, 0.26) 1px solid !important;
		border-radius: 4px;
	}

	.select-author__favorite {
		width: 25px;
		height: 25px;
		cursor: pointer;

		img {
			width: 100%;
			height: 100%;
		}
	}

	.search .vs-icon {
		height: 100%;
		width: 35px;
		background: $primary;
		position: absolute;
		top: 0;
		right: 0;
		color: white !important;
		display: flex;
		align-items: center;
		justify-content: center;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		font-size: 22px;
	}
}

.author-search-requests {
	&__photo {
		flex: 30px 0 0;
	}
}
</style>
